import { LOGGED_USER } from "../actions-constants/loggedUser.constants";

export function userLoggedIn(user) {
    return {
        type: LOGGED_USER.USER_LOGGED_IN,
        user: user
    }
}

export function userLoggedOut() {
    return {
        type: LOGGED_USER.USER_LOGGED_OUT
    }
}